// src/pages/admin/AdminVendorPayments.jsx

import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  orderBy,
  query,
  updateDoc,
  doc,
  serverTimestamp
} from "firebase/firestore";

function formatMoney(v) {
  return Number(v || 0).toLocaleString("fr-FR") + " FCFA";
}

export default function AdminVendorPayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingId, setProcessingId] = useState(null);

  const loadPayments = async () => {
    try {
      setLoading(true);

      const q = query(
        collection(db, "subscriptionPayments"),
        orderBy("createdAt", "desc")
      );

      const snap = await getDocs(q);

      const list = snap.docs.map((d) => ({
        id: d.id,
        ...d.data()
      }));

      setPayments(list);
    } catch (err) {
      console.error(err);
      alert("Erreur chargement paiements");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPayments();
  }, []);

  const confirmPayment = async (payment) => {
    if (!window.confirm("Confirmer ce paiement ?")) return;

    try {
      setProcessingId(payment.id);

      // paiement
      await updateDoc(
        doc(db, "subscriptionPayments", payment.id),
        {
          status: "paid",
          confirmedAt: serverTimestamp()
        }
      );

      // activer vendeur
      if (payment.vendorUid) {
        await updateDoc(
          doc(db, "users", payment.vendorUid),
          {
            paymentStatus: "paid",
            subscriptionStatus: "active",
            subscriptionValidUntil: new Date(
              Date.now() + 30 * 24 * 60 * 60 * 1000
            ),
            updatedAt: serverTimestamp()
          }
        );
      }

      alert("Paiement confirmé");

      loadPayments();

    } catch (err) {
      console.error(err);
      alert("Erreur confirmation paiement");
    } finally {
      setProcessingId(null);
    }
  };

  const rejectPayment = async (payment) => {
    if (!window.confirm("Refuser ce paiement ?")) return;

    try {
      setProcessingId(payment.id);

      await updateDoc(
        doc(db, "subscriptionPayments", payment.id),
        {
          status: "rejected",
          rejectedAt: serverTimestamp()
        }
      );

      alert("Paiement refusé");

      loadPayments();

    } catch (err) {
      console.error(err);
      alert("Erreur refus paiement");
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div className="page">

      <h1 className="title">
        Paiements abonnements vendeurs
      </h1>

      {loading ? (
        <p>Chargement…</p>
      ) : payments.length === 0 ? (
        <p>Aucun paiement</p>
      ) : (
        <table className="table">

          <thead>
            <tr>
              <th>Montant</th>
              <th>Téléphone</th>
              <th>Statut</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {payments.map((p) => (
              <tr key={p.id}>

                <td>{formatMoney(p.amount)}</td>

                <td>{p.phone || "—"}</td>

                <td>
                  <span className={`status status-${p.status}`}>
                    {p.status}
                  </span>
                </td>

                <td>
                  {p.createdAt?.toDate
                    ? p.createdAt.toDate().toLocaleString()
                    : "—"}
                </td>

                <td>

                  {p.status === "pending" && (
                    <>
                      <button
                        className="btn confirm"
                        disabled={processingId === p.id}
                        onClick={() => confirmPayment(p)}
                      >
                        Confirmer
                      </button>

                      <button
                        className="btn reject"
                        disabled={processingId === p.id}
                        onClick={() => rejectPayment(p)}
                      >
                        Refuser
                      </button>
                    </>
                  )}

                  {p.status === "paid" && (
                    <span className="paidLabel">
                      Payé
                    </span>
                  )}

                </td>

              </tr>
            ))}
          </tbody>

        </table>
      )}

      <style>{`

      .page{
        padding:30px;
        background:#f8fafc;
        min-height:100vh;
      }

      .title{
        font-size:24px;
        font-weight:900;
        margin-bottom:20px;
      }

      .table{
        width:100%;
        border-collapse:collapse;
        background:white;
        border-radius:14px;
        overflow:hidden;
      }

      th,td{
        padding:12px;
        border-bottom:1px solid #e5e7eb;
        text-align:left;
        font-size:14px;
      }

      th{
        background:#f1f5f9;
        font-weight:800;
      }

      .status{
        padding:4px 10px;
        border-radius:999px;
        font-size:12px;
        font-weight:800;
      }

      .status-pending{
        background:#fef9c3;
        color:#92400e;
      }

      .status-paid{
        background:#dcfce7;
        color:#166534;
      }

      .status-rejected{
        background:#fee2e2;
        color:#b91c1c;
      }

      .btn{
        padding:6px 12px;
        border-radius:999px;
        border:none;
        cursor:pointer;
        font-weight:700;
        margin-right:6px;
      }

      .confirm{
        background:#16a34a;
        color:white;
      }

      .reject{
        background:#dc2626;
        color:white;
      }

      .paidLabel{
        color:#16a34a;
        font-weight:900;
      }

      `}</style>

    </div>
  );
}